// Le differenze dei filtri e dell'ordine di chiamata fra due versioni di una Smart List (piano M3, D8; decisione P30):
// una regola sola per lo «Storico della lista» del server e per «Modifiche non salvate» della pagina della lista.
// Funzioni pure, senza dipendenze: i tipi sono la forma delle condizioni di `FilterDefinition` v1 (`@gioia365/contracts`).
//
// I filtri si confrontano per campo e per contenuto: le condizioni di un campo in un altro ordine, o con le voci in un
// altro ordine o ripetute, sono le stesse, e non fanno una versione. Ogni campo che cambia è una differenza sola: aggiunto
// (`filter_added`), tolto (`filter_removed`) o cambiato (`filter_changed`, anche da «è» a «non è»), con le condizioni di
// prima e di dopo com'erano scritte. Combinatore e gruppi, che l'interfaccia di M3 non costruisce (D1), sono la
// «struttura» del filtro: se cambiano, una `filter_changed` senza campo con il prima e il dopo. L'ordine delle differenze
// è quello dei campi della versione nuova (aggiunti e cambiati), poi i tolti nell'ordine della vecchia.
/** La forma confrontabile di una condizione: voci in ordine e senza ripetizioni. */
function normalizedCondition(condition) {
    switch (condition.kind) {
        case "choice":
        case "tags":
            return JSON.stringify([condition.kind, condition.field, condition.op, [...new Set(condition.values)].sort()]);
        case "number":
            return JSON.stringify([condition.kind, condition.field, condition.op, condition.value]);
        case "date":
        case "task":
            return JSON.stringify([condition.kind, condition.field, condition.op, condition.day ?? null]);
        case "email":
            return JSON.stringify([condition.kind, condition.field, condition.op, condition.days ?? null]);
    }
}
/** Le condizioni per campo, nell'ordine in cui i campi compaiono. */
function byField(conditions) {
    const fields = new Map();
    for (const condition of conditions) {
        const list = fields.get(condition.field);
        if (list)
            list.push(condition);
        else
            fields.set(condition.field, [condition]);
    }
    return fields;
}
const conditionsKey = (conditions) => [...new Set(conditions.map(normalizedCondition))].sort().join("\n");
/** Il valore di una differenza: la condizione del campo, o le condizioni se sono più d'una. */
const valueOf = (conditions) => (conditions.length === 1 && conditions[0] ? conditions[0] : [...conditions]);
/** Combinatore e gruppi in forma confrontabile: i gruppi come insiemi di condizioni, in qualunque ordine. */
function structureKey(definition) {
    const groups = definition.groups.map((group) => JSON.stringify([group.combinator, [...new Set(group.conditions.map(normalizedCondition))].sort()])).sort();
    return JSON.stringify([definition.combinator, groups]);
}
/** Le differenze dei filtri fra due definizioni (vedi l'intestazione). */
export function diffDefinitions(before, after) {
    const previous = byField(before.conditions);
    const next = byField(after.conditions);
    const changes = [];
    for (const [field, conditions] of next) {
        const old = previous.get(field);
        if (!old)
            changes.push({ kind: "filter_added", field, after: valueOf(conditions) });
        else if (conditionsKey(old) !== conditionsKey(conditions))
            changes.push({ kind: "filter_changed", field, before: valueOf(old), after: valueOf(conditions) });
    }
    for (const [field, conditions] of previous) {
        if (!next.has(field))
            changes.push({ kind: "filter_removed", field, before: valueOf(conditions) });
    }
    if (structureKey(before) !== structureKey(after)) {
        changes.push({ kind: "filter_changed", before: { combinator: before.combinator, groups: before.groups }, after: { combinator: after.combinator, groups: after.groups } });
    }
    return changes;
}
/** L'ordine di chiamata cambiato: colonna o direzione. */
export function diffSort(before, after) {
    return before.field === after.field && before.direction === after.direction ? [] : [{ kind: "sort_changed", before, after }];
}
//# sourceMappingURL=smart-list-diff.js.map